/**
 * Helper function to check if selectedItem's parent is selected
 * @param {[]} allSelectedItems - all selected filter items in an array
 * @param {Object} selectedItem - selected filter item object to check if its parent is selected by parentSlug
 * @returns {boolean} returns boolean to check if selectedItem's parent is selected
 */
export const isParentOrganisationSelected = (allSelectedItems, selectedItem) => {
    if (selectedItem.parentSlug === null) {
        return true;
    }

    return allSelectedItems.some((listItem) => {
        if (listItem.slug === selectedItem.parentSlug) {
            if (listItem.parentSlug === null) {
                return true;
            }
            return isParentOrganisationSelected(allSelectedItems, listItem);
        }
        return false;
    });
};

/**
 * Helper function to get all selected filter items in an array of object
 * @param {Object} data - selectedItems
 * @returns {[]} new array for selected filter items
 */
export const getCollectionOfSelectedFilterItems = (data) => {
    const selectedFilterItems = [];

    Object.keys(data).forEach((selectedItemType) => {
        Object.values(data[selectedItemType]).forEach((item) => {
            selectedFilterItems.push({
                accountHasRoleId: item.accountHasRoleId,
                id: item.id,
                name: item.name,
                parentSlug: item.parentSlug || null,
                slug: item.slug,
                type: selectedItemType,
            });
        });
    });

    return selectedFilterItems;
};
